import { Components, Theme } from "@mui/material/styles";

export const MuiOutlinedInput: Components<Theme>["MuiOutlinedInput"] = {
    styleOverrides: {
        root: {
            width: "100%",
            backgroundColor: "white",
            minWidth: 0,
            outline: 0,
            position: "relative",
            appearance: "none",
            transitionProperty: "common",
            transitionDuration: "normal",
            borderRadius: "8px",
            fontSize: "16px",
            lineHeight: "1.5",
            outlineOffset: "2px",
            height: "48px",

            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--mui-palette-gray-400)",
                boxShadow: "none",
                transition: "box-shadow 0.2s ease",
            },

            "&:hover:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--mui-palette-gray-800)",
            },

            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--mui-palette-gray-800)",
                borderWidth: "1px",
                boxShadow: `rgb(51, 51, 51) 0px 0px 0px 1px`,
            },

            "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--mui-palette-gray-400)",
            },

            "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--mui-palette-red-700)",
            },

            "&.Mui-error": {
                background: "#fff1ef",
            },

            "&:hover.Mui-error .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--mui-palette-red-700)",
            },

            "&.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--mui-palette-red-700)",
                borderWidth: "1px",
                boxShadow: `var(--mui-palette-red-700) 0px 0px 0px 1px`,
            },

            "&.Mui-disabled": {
                background: "var(--mui-palette-gray-50)",
                color: "var(--mui-palette-gray-800)",
                "& .MuiOutlinedInput-input": {
                    cursor: "not-allowed",
                },
            },

            "&.MuiInputBase-sizeSmall": {
                height: "40px",
            },
            "&.MuiInputBase-sizeLarge": {
                height: "56px",
            },
        },

        input: {
            padding: "0 16px",
            height: "100%",

            "&::placeholder": {
                color: "var(--mui-palette-gray-500)",
                opacity: 1,
            },

            "&.Mui-disabled": {
                color: "var(--mui-palette-gray-500)",
                WebkitTextFillColor: "var(--mui-palette-gray-500)",
            },

            // Override webkit autofill styles
            "&:-webkit-autofill": {
                WebkitBoxShadow: "none",
                WebkitTextFillColor: "inherit",
                caretColor: "inherit",
                backgroundColor: "transparent",
            },
            "&:-webkit-autofill:hover": {
                WebkitBoxShadow: "none",
                WebkitTextFillColor: "inherit",
            },
            "&:-webkit-autofill:focus": {
                WebkitBoxShadow: "none",
                WebkitTextFillColor: "inherit",
            },
            "&:-webkit-autofill:active": {
                WebkitBoxShadow: "none",
                WebkitTextFillColor: "inherit",
            },
        },
    },
};
